import { render, staticRenderFns } from "./AdminEmail.vue?vue&type=template&id=6b22f7bc&"
import script from "./AdminEmail.vue?vue&type=script&lang=js&"
export * from "./AdminEmail.vue?vue&type=script&lang=js&"
import style0 from "./AdminEmail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports